function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.2062 6.40039L10.9172 1.11329C10.8397 1.03583 10.7403 0.998535 10.6399 0.998535H0.97505C0.757981 0.998535 0.582031 1.17449 0.582031 1.38964V22.5409C0.582031 22.758 0.757981 22.934 0.97505 22.934H15.9298C16.1469 22.934 16.3219 22.758 16.3219 22.5409V6.6777C16.3219 6.5706 16.2779 6.47307 16.2062 6.40039ZM11.031 2.33633L14.9822 6.28564H11.031V2.33633ZM15.5378 22.1498H1.36616V1.78266H10.2478V6.67866C10.2478 6.89382 10.4228 7.06977 10.6399 7.06977H15.5378V22.1498Z",
  fill: "currentColor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3.23145 10.342C3.23145 10.5591 3.35965 10.7341 3.51867 10.7341H10.5942C10.7525 10.7341 10.8814 10.5581 10.8814 10.342C10.8814 10.1269 10.7525 9.95093 10.5942 9.95093H3.51797C3.35965 9.95093 3.23145 10.1269 3.23145 10.342Z",
  fill: "currentColor"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2816 12.8093H3.62253C3.40546 12.8093 3.23047 12.9853 3.23047 13.2014C3.23047 13.4165 3.40546 13.5925 3.62253 13.5925H13.2816C13.4977 13.5925 13.6737 13.4165 13.6737 13.2014C13.6737 12.9853 13.4987 12.8093 13.2816 12.8093Z",
  fill: "currentColor"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2816 15.6721H3.62253C3.40546 15.6721 3.23047 15.8481 3.23047 16.0642C3.23047 16.2803 3.40546 16.4562 3.62253 16.4562H13.2816C13.4977 16.4562 13.6737 16.2803 13.6737 16.0642C13.6737 15.8481 13.4987 15.6721 13.2816 15.6721Z",
  fill: "currentColor"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2816 18.5315H3.62253C3.40546 18.5315 3.23047 18.7074 3.23047 18.9236C3.23047 19.1397 3.40546 19.3156 3.62253 19.3156H13.2816C13.4977 19.3156 13.6737 19.1397 13.6737 18.9236C13.6737 18.7074 13.4987 18.5315 13.2816 18.5315Z",
  fill: "currentColor"
});

var SvgDoc = function SvgDoc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 24,
    viewBox: "0 0 17 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/doc.864f70a9.svg";
export { ForwardRef as ReactComponent };